import { ConnectorLogo } from "../../ConnectorLogo";
import { ConnectorLogoContainer } from "../../ConnectorLogoContainer";
import { Icon } from "../../Icon";
import type { IdentityProvider } from "./identityProviders";

export function IdpLogo({ idp }: { idp: IdentityProvider }) {
  return idp.logo ? (
    <ConnectorLogo
      template={{ name: idp.name, identifier: idp.logo }}
      size={16}
    />
  ) : (
    <Icon name="shield-check" size={16} />
  );
}

export function IdpLogoBadge({ idp }: { idp: IdentityProvider }) {
  return (
    <ConnectorLogoContainer size={32} borderRadius={8} hoverBackground={false}>
      <IdpLogo idp={idp} />
    </ConnectorLogoContainer>
  );
}
